import BaseComponent from './BaseComponent';

class Banner extends BaseComponent {
  constructor(componentName) {
    super(componentName);
  }

  init(component) {
    this.addCustomEvents(component);

    this.setBackgroundColor(component.element)

    setTimeout(() => {
      this.setVisibility(component.element);
      this.setProgression(component.element);
    }, 300)
    this.storeInfo(component);
  }

  addCustomEvents(component) {
    const element     = component.element;
    const closeButton = element.getElementsByClassName('close')[0];


    if(closeButton) {
      closeButton.addEventListener('click', () => {
        this.hide(element);
      })
    }
  }

  add(banner) {
    const bannerExist = document.querySelector(`li[data-banner-id="${banner.id}"]`);
    if(bannerExist) {
      this.update(banner);
      return;
    }
    const string = `<li class='cmp-banner' data-url='${banner.close}' data-banner-id='${banner.id}' data-temp-visible='${banner.visible}' data-progression='${banner.progression}'>
      <aside class='banner banner--promo-progress'>
        <div class='progression'></div>
          <p class=''>
            <span class='banner__message'>${banner.message}</span>
            ${banner.info ? this.addInfoButton(id) : ''}
          </p>
        </div>
        <button class='close is-active'>
          <span class='close-box'>
            <span class='close-inner'></span>
          </span>
        </button>
      </aside>
    </li>`;

    this.storeBanner(banner);

    const bannerTag = app.parser.parseToHTML(string);
    const bannersList = document.getElementsByClassName('list--banners')[0];

    if (bannersList) {
      bannersList.appendChild(bannerTag);
      const newBanner = document.querySelector(`li[data-banner-id="${banner.id}"]`);
    } else {
      console.warn('There is no banner list on this page 🤦🏽‍♂️');
    }
  }

  update(banner){
    const targetBanner = document.querySelector(`li[data-banner-id="${banner.id}"]`);
    if (targetBanner) {
      // Update text if needed
      const messageWrapper = targetBanner.getElementsByClassName('banner__message')[0];

      // For HTML inner content
      messageWrapper.innerHTML = banner.message;
      messageWrapper.appendChild = app.parser.parseToHTML(this.addInfoButton(banner.id));
      // For Plain text
      // messageWrapper.textContent = banner.message;

      // Update progression if needed
      targetBanner.setAttribute('data-progression', banner.progression);
      this.setProgression(targetBanner);
      this.setBackgroundColor(targetBanner);
    }
  }

  remove(id) {
    const targetBanner = document.querySelector(`li[data-banner-id="${banner.id}"]`);
    // height 0
    this.hide(targetBanner);
    // TODO then remove
    this.updatePagePadding(false);
  }

  hide(banner) {
    banner.setAttribute('data-visible', false);
    this.updatePagePadding(false);
    // Post action to backend
    const url = banner.getAttribute('data-url');
    app.ajax.rails(url, 'POST');
  }

  addInfoButton(id) {
    return `<button class='cmp-modal-trigger info' data-banner-id='${id}' data-modal-target='banner-progression'><i><img src='/assets/front/icon--info.svg' /></i></button>`
  }

  setVisibility(banner) {
    const visible = banner.getAttribute('data-temp-visible') == 'true';
    banner.setAttribute('data-visible', visible);
    banner.removeAttribute('data-temp-visible');

    this.updatePagePadding(visible);
  }

  setProgression(banner) {
    const progression    = banner.getAttribute('data-progression');
    const progressionBar = banner.getElementsByClassName('progression')[0];
    progressionBar.style.width = progression + '%';
  }

  storeInfo(component) {
    const id          = component.element.getAttribute('data-banner-id');
    const title       = banners[id].title;
    const description = banners[id].description;

    component.info = { title, description }
  }

  storeBanner(banner) {
    if(!window.banners) window.banners = {};
    banners[`${banner.id}`] = banner;
  }

  updateModalContent(id, modal) {
    const heading = modal.getElementsByClassName('title-text')[0];
    const paragraph = modal.getElementsByClassName('modal-paragraph')[0];

    // Clear previous content
    removeAllChild(heading);
    removeAllChild(paragraph);

    // Update with the new content
    heading.appendChild(app.parser.parseToHTML(banners[id].info.title));
    paragraph.appendChild(app.parser.parseToHTML(banners[id].info.description));
  }

  updatePagePadding(increase = true) {
    const content = document.getElementById('scrollbar-wrapper');
    let previousPaddingTop = parseInt(content.style.paddingTop.split('px')[0]);
    let currentPaddingTop  = increase ? previousPaddingTop + 30 : previousPaddingTop - 30;
    content.style.paddingTop = currentPaddingTop + 'px';
  }

  setBackgroundColor(banner) {
    const progression = banner.getAttribute('data-progression');
    banner.firstElementChild.style.backgroundColor = this.getColor({ progression })
  }

  getColor({ c1 = '#FEC043', c2 = '#FE7443', progression }) {
    const couponAchieved = '#4377FE'

    if(progression >= 100) return couponAchieved;

    // Hexadecimal String to rgb array [r,g,b]
    function h2r(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ] : null;
    };

    // rgb array [r,g,b] to hexadecimal String
    function r2h(rgb) {
      return "#" + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1);
    };

    const color1 = h2r(c1);
    const color2 = h2r(c2);

    // Interpolates two [r,g,b] colors and returns an [r,g,b] of the result
    let color = color1.slice();
    for (let i = 0; i < 3; i++) {
      color[i] = Math.round(color[i] + (progression/100) * (color2[i] - color1[i]));
    }

    return r2h(color);
  }
}

export default Banner;
